﻿import { Component, ViewChild} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BsModalComponent } from 'ng2-bs3-modal';

import { SubTopic } from '../shared/types/sub-topic.type';
import { SubTopicService } from '../shared/services/sub-topic.service'

@Component({
  selector: 'sub-topic',
  templateUrl: './sub-topic.html',
  styleUrls: ['./sub-topic.css']
})

export class SubTopicComponent {

  @ViewChild('addModal')
  addModal: BsModalComponent;

  @ViewChild('editModal')
  editModal: BsModalComponent;

  @ViewChild('deleteModal')
  deleteModal: BsModalComponent;

  @ViewChild('questionExists')
  questionExists: BsModalComponent;

  subTopics: SubTopic[];
  selectedSubTopic: SubTopic;

  newSubTopicName: string = null;
  errorMessage: string;

  objectExistsMessage: string = "Question(s) exist with this topic.  You must first delete the question(s).";

  constructor(public _route: ActivatedRoute, public _subTopicService: SubTopicService) { }

  ngOnInit() {
   
    this.getSubTopics();

  }

  getSubTopics() {
    this._subTopicService.getSubTopics().subscribe((data: any[]) => {
      this.subTopics = data;
    })
  }

  editSubTopic() {
    if (this.selectedSubTopic.SubTopicName != null && this.selectedSubTopic.SubTopicName != '') {
      this._subTopicService.postSubTopic(this.selectedSubTopic).subscribe(data => {
        this.getSubTopics();
        this.editModal.dismiss();
      })
    } else {
      this.errorMessage = "Sub topic Name is required."
    }
  }

  addSubTopic() {

    if (this.newSubTopicName != null) {
        var exist = this.subTopics.filter(t => t.SubTopicName.toLowerCase() == this.newSubTopicName.toLowerCase());
        if (exist && exist.length == 0) {
            let subTopic = new SubTopic;
            subTopic.SubTopicName = this.newSubTopicName;

            this._subTopicService.postSubTopic(subTopic).subscribe(data => {
                this.getSubTopics();
                this.addModal.dismiss();
                this.newSubTopicName = null;
            })
        }
        else {
            this.errorMessage = "SubTopic Name already exists."
        }
    } else {
      this.errorMessage = "Sub topic Name is required."
    }
  }

  deleteSubTopic() {
    this._subTopicService.deleteSubTopic(this.selectedSubTopic.SubTopicId).subscribe(data => {

      if (data == "question exists")
      {
        this.objectExistsMessage = "Question(s) exist with this sub topic.  You must first delete the question(s).";
        this.deleteModal.dismiss();
        this.questionExists.open();
      }
      else if (data == "userchart exists")
      {
        this.objectExistsMessage = "User Charts(s) exist with this sub topic.  You must first delete the user chart(s).";
        this.deleteModal.dismiss();
        this.questionExists.open();
      }
      else
      {
        this.deleteModal.dismiss();
        this.getSubTopics();
      }

    })
  }

  openAddModal() {
    this.errorMessage = "";
    this.newSubTopicName = "";
    this.addModal.open();
  }

  openEditModal(subTopic) {
    this.errorMessage = "";
    this.selectedSubTopic = { ...subTopic };
    this.editModal.open();
  }

  openDeleteModal(subTopic) {
    this.selectedSubTopic = subTopic;
    this.deleteModal.open();
  }

}
